import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import {
  APP_MODE,
  Appointment,
  BusinessObject,
  CalendarAdditionalConfig,
} from '../../../models';
import { CalendarAppointmentChatBoxComponent } from '../calendar-appointment-chat-box/calendar-appointment-chat-box.component';
import { CustomerUtils } from '../../../utils';

export interface CalendarAppointmentChatBoxDialogComponentData {
  businessObject: BusinessObject;
  appointment: Appointment;
  mode: APP_MODE;
  calendarAdditionalConfig?: CalendarAdditionalConfig;
}
@Component({
  selector: 'lib-calendar-appointment-chat-box-dialog',
  templateUrl: './calendar-appointment-chat-box-dialog.component.html',
  styleUrls: ['./calendar-appointment-chat-box-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, CalendarAppointmentChatBoxComponent],
})
export class CalendarAppointmentChatBoxDialogComponent {
  public businessObject: BusinessObject;
  public appointment: Appointment;
  public mode: APP_MODE;
  private calendarAdditionalConfig: CalendarAdditionalConfig;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: CalendarAppointmentChatBoxDialogComponentData,
    private dialogRef: MatDialogRef<CalendarAppointmentChatBoxDialogComponent>
  ) {
    this.businessObject = this.data?.businessObject;
    this.appointment = this.data?.appointment;
    this.mode = this.data?.mode;
    this.calendarAdditionalConfig = this.data?.calendarAdditionalConfig;
  }

  public isEditActionForbiddenForStaffApp(): boolean {
    return CustomerUtils.isEditActionForbiddenForStaffApp(
      this.mode,
      this.appointment?.staffId,
      this.calendarAdditionalConfig?.primaryStaffId,
      this.calendarAdditionalConfig?.forbiddenActions
    );
  }

  public closeDialog(): void {
    this.dialogRef.close(this.appointment);
  }
}
